import { RadioButton, Card, BlockStack, Text, Layout, InlineStack, Box, Banner, InlineError } from '@shopify/polaris';
import React, { ReactElement } from 'react';
import { DI, DIProps } from '../../../../../Core';
import useContextLayer from '../../Context/helper';
import { useTranslation } from "react-i18next";
import useContainerState from "../../Context/ContainerState";


interface Props extends DIProps { validatorError: any }

function FulfillmentType(props: Props): ReactElement {
    const { t } = useTranslation();
    const { state, dispatch } = useContextLayer();
    const { containerState } = useContainerState()


    const handleChange = (change: boolean, newValue: string) => {
        dispatch({
            type: 'fulfillment_type',
            payload: {
                fulfillment_type: newValue
            }
        });
        if (newValue == "FBA") {
            dispatch({
                type: 'selection_type',
                payload: {
                    inventory_fulfillment_latency: "default"
                }
            });
        }
    }

    return <>
        {Object.keys(state).length > 0 &&
            <div id='tour_fullfilment'>
                {/* <Layout.AnnotatedSection
                    title={<Text as='p'>Fulfilment Type <Text as='span' tone='critical'>*</Text></Text>}
                    description={"Choose your shipping/ fulfilment preference for the selected category."}
                >
                    <Card roundedAbove='sm'>
                        <BlockStack gap="100">
                            <RadioButton
                                label="FBM (Fulfilment by Merchant)"
                                checked={state?.['data']?.['fulfillment_type'] == 'FBM'}
                                name="FBM"
                                id='FBM'
                                onChange={handleChange}
                            />
                            <RadioButton
                                label="FBA (Fulfilment by Amazon)"
                                name="FBA"
                                id='FBA'
                                checked={state?.['data']?.['fulfillment_type'] == 'FBA'}
                                onChange={handleChange}
                            />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection> */}
                <Card roundedAbove='sm'>
                    <Layout>
                        <Layout.AnnotatedSection
                            id="fulfilmet_type"
                            title={t("Fulfilment Type")}
                            description={t("Choose your shipping/ fulfilment preference for the selected category.")}
                        >
                            {/* <div className='Custom-Polaris-Box'> */}
                            <div className={props?.validatorError?.fulfillment_type ? 'Custom-Polaris-Box custom-error-description' : 'Custom-Polaris-Box'}>
                                <Box padding='400' background="bg-surface-secondary" borderRadius='300' borderWidth='025' borderColor='border'>
                                    <InlineStack gap="300">
                                        <RadioButton
                                            label={t("FBM (Fulfilment by Merchant)")}
                                            checked={state?.['data']?.['fulfillment_type'] == 'FBM'}
                                            name="FBM"
                                            id='FBM'
                                            onChange={handleChange}
                                        />
                                        <RadioButton
                                            label={t("FBA (Fulfilment by Amazon)")}
                                            name="FBA"
                                            id='FBA'
                                            checked={state?.['data']?.['fulfillment_type'] == 'FBA'}
                                            onChange={handleChange}
                                        />
                                    </InlineStack>
                                    {containerState.initialProductData['hasVariants'] && <Banner tone='info'>{t("This is a parent product so fulfillment type rules will be applied on all the variant products rather than this parent product.")}</Banner>}
                                    {props?.validatorError?.fulfillment_type && <InlineError fieldID='inlineErrorFulfillmentType' message={props?.validatorError?.['fulfillment_type']} />}
                                </Box>
                            </div>
                        </Layout.AnnotatedSection>
                    </Layout>
                    {/* <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>
                                Fulfilment Type
                            </Text>
                            <Text as='p'>
                                Choose your shipping/ fulfilment preference for the selected category.
                            </Text>
                            <BlockStack gap="100">
                                <RadioButton
                                    label="FBM (Fulfilment by Merchant)"
                                    checked={state?.['data']?.['fulfillment_type'] == 'FBM'}
                                    name="FBM"
                                    id='FBM'
                                    onChange={handleChange}
                                />
                                <RadioButton
                                    label="FBA (Fulfilment by Amazon)"
                                    name="FBA"
                                    id='FBA'
                                    checked={state?.['data']?.['fulfillment_type'] == 'FBA'}
                                    onChange={handleChange}
                                />
                            </BlockStack>
                        </BlockStack> */}
                </Card>
            </div>
        }
    </>;
}

export default DI(FulfillmentType);